<div class="spinner">
  <mat-spinner [diameter]="30"></mat-spinner>
</div>
